<template>
  <!--
    For security reason, markdown-it html rendering should be **false**.
    See https://github.com/markdown-it/markdown-it/blob/master/docs/security.md
  -->
  <VueMarkdown
    v-if="source"
    class="markdown-content"
    :html="false"
    :source="source"
    :plugins="plugins"
  />
</template>

<script lang="ts">
import { full as MarkdownItEmoji } from 'markdown-it-emoji'
import { defineComponent } from 'vue'
import VueMarkdown from 'vue-markdown-render'

export default defineComponent({
  components: {
    VueMarkdown,
  },
  props: {
    source: {
      type: String,
      required: true,
    },
  },
  setup() {
    return { plugins: [MarkdownItEmoji] }
  },
})
</script>

<style lang="scss">
// WARNING, UNSCOPED
// This is intentional -- the class will not apply to the markdown otherwise
// even with :deep applied

// remove double lists when formatted from NABLA with
// "+ 1. this is a step"
.markdown-content ul:has(ol) {
  list-style: none;
}
</style>
